import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ToastNotificationService } from '../../../services/toast-notification.service';
import { SettingsService } from '../../../services/settings.service';
import { MatFormField, MatInput, MatSuffix, MatError } from '@angular/material/input';
import { InlineSvgComponent } from '../../../components/inline-svg/inline-svg.component';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'frmg-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  imports: [ReactiveFormsModule, MatFormField, MatInput, InlineSvgComponent, MatSuffix, MatError, MatButton]
})
export class ChangePasswordComponent implements OnInit {
  public passwordFg: FormGroup;
  public hidePassword: Array<boolean> = [true, true, true];

  constructor(
    private fb: FormBuilder,
    private toastNotificationService: ToastNotificationService,
    private settingsService: SettingsService
  ) {
  }

  ngOnInit() {
    this.passwordFg = this.fb.group({
      current_password: ['', [Validators.required, Validators.minLength(8)]],
      new_password: ['', [Validators.required, Validators.minLength(8)]],
      confirm_new_password: ['', [Validators.required, Validators.minLength(8)]]
    }
    );
  }

  togglePasswordVisibility(index: number): void {
    this.hidePassword[index] = !this.hidePassword[index];
  }

  changePassword(): void {
    const passwordData = this.passwordFg.value;

    if (passwordData.new_password !== passwordData.confirm_new_password) {
      this.toastNotificationService.showNotification({
        type: 'error',
        message: 'Passwords does not match.'
      });
      return;
    }

    this.settingsService.changePassword(passwordData)
      .subscribe(
        () => {
          this.toastNotificationService.showNotification({ type: 'success', message: 'Password changed successfully.' });
          this.passwordFg.setValue({
            current_password: '',
            new_password: '',
            confirm_new_password: ''
          });
        },
        () => {
          this.toastNotificationService.showNotification({
            type: 'error',
            message: 'An error occurred while changing the password.'
          });
        }
      );
  }
}
